async function devtricker_ajax_get_getDevtrickerNonce() {
    try {
        const response = await fetch('/wp-admin/admin-ajax.php?action=devtricker_fetch_nonce', { credentials: 'same-origin' });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, "devtricker_nonce obtained successfully.");
            return result.data.nonce;
        } else {
            throw new Error('Failed to obtain the devtricker_nonce.');
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}

async function devtricker_ajax_get_devtricker_getDevtrickerLoginNonce() {
    try {
        const response = await fetch('/wp-admin/admin-ajax.php?action=devtricker_account_login_email_action_fetch_login_nonce_ajax', { credentials: 'same-origin' });

        const data = await response.json();

        if (data.success) {

            devtricker_log(null, devtricker_log_level.INFO, "devtricker_login_nonce obtained successfully");

            nonce = data.data.nonce;
            return nonce;
        } else {
            throw new Error('Failed to obtain the devtricker_login_nonce.');
        }

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);

        throw error;
    }
}

async function devtricker_ajax_get_getDevtrickerLogoutNonce() {
    try {
        const response = await fetch('/wp-admin/admin-ajax.php?action=devtricker_account_logout_action_fetch_logout_nonce_ajax', { credentials: 'same-origin' });

        const data = await response.json();

        if (data.success) {

            devtricker_log(null, devtricker_log_level.INFO, "devtricker_logout_nonce obtained successfully");
            
            nonce = data.data.nonce;
            return nonce;
        } else {
            throw new Error('Failed to obtain the devtricker_logout_nonce.');
        }

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);

        throw error;
    }
}

async function devtricker_ajax_get_getDevtrickerRecoverNonce() {
    try {
        const response = await fetch('/wp-admin/admin-ajax.php?action=devtricker_account_recover_action_fetch_logout_nonce_ajax', { credentials: 'same-origin' });

        const data = await response.json();

        if (data.success) {

            devtricker_log(null, devtricker_log_level.INFO, "devtricker_recover_nonce obtained successfully");
            
            nonce = data.data.nonce;
            return nonce;
        } else {
            throw new Error('Failed to obtain the devtricker_recover_nonce.');
        }

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);

        throw error;
    }
}

async function devtricker_ajax_get_getDevtrickerAccountCreationNonce() {
    try {
        const response = await fetch('/wp-admin/admin-ajax.php?action=devtricker_action_fetch_account_creation_nonce_ajax', { credentials: 'same-origin' });

        const result = await response.json();

        if (result.success) {
            devtricker_log(null, devtricker_log_level.INFO, "devtricker_account_creation_nonce obtained successfully.");
            return result.data.nonce;
        } else {
            throw new Error('Failed to obtain the devtricker_account_creation_nonce.');
        }
    } catch (error) {
        devtricker_log(error, devtricker_log_level.ERROR);
        throw error;
    }
}